export { CardInfoAreaEntityMobile } from './card-info-area';
